module.exports = __webpack_public_path__ + "static/img/share_img6.364ccf13.png";